var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_35719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5C28 6.76801 21.732 0.5 14 0.5C6.26801 0.5 0 6.76801 0 14.5C0 21.4877 5.11957 27.2796 11.8125 28.3299V18.5469H8.25781V14.5H11.8125V11.4156C11.8125 7.90688 13.9027 5.96875 17.1005 5.96875C18.6318 5.96875 20.2344 6.24219 20.2344 6.24219V9.6875H18.4691C16.73 9.6875 16.1875 10.7668 16.1875 11.875V14.5H20.0703L19.4496 18.5469H16.1875V28.3299C22.8804 27.2796 28 21.4877 28 14.5Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4496 18.5469L20.0703 14.5H16.1875V11.875C16.1875 10.7679 16.73 9.6875 18.4691 9.6875H20.2344V6.24219C20.2344 6.24219 18.6323 5.96875 17.1005 5.96875C13.9027 5.96875 11.8125 7.90688 11.8125 11.4156V14.5H8.25781V18.5469H11.8125V28.3299C13.262 28.5567 14.738 28.5567 16.1875 28.3299V18.5469H19.4496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_35719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.c8b8c36b62ffb2ee320fac15666782ff.svg";
export { ForwardRef as ReactComponent };